export default __webpack_public_path__ + "static/media/phonebooth_lightOff.89d33fd5.webp";